import { http } from "./client";

export const BookingsAPI = {
  listAdmin: () => http("/admin/bookings"),
  updateStatus: (id, status) =>
    http(`/admin/bookings/${id}/status`, {
      method: "POST",
      body: JSON.stringify({ status }),
    }),
  remove: (id) => http(`/admin/bookings/${id}`, { method: "DELETE" }),
};
